
export default defineNuxtPlugin(() => {
    const sanitizeHref = (text) => {
        if (text && text.replace) {
            return text.replace('javascript:', '')
        } else {
            return text
        }
    }

    return {
        provide: {
            sanitizeHref
        }
    }
})
